var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fillRule: "evenodd"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.648 3.5A2.15 2.15 0 0 0 1.5 5.648V11A2.5 2.5 0 0 0 4 13.5h7a2.5 2.5 0 0 0 2.5-2.5V5.889c0-1.32-1.07-2.389-2.389-2.389v-1A3.39 3.39 0 0 1 14.5 5.889V11a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 11V5.648A3.15 3.15 0 0 1 3.648 2.5z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.376.5a.5.5 0 0 1 .5.5v7.192l2.513-2.66a.5.5 0 1 1 .727.686l-3.74 3.96-3.74-3.96a.5.5 0 0 1 .728-.686l2.512 2.66V1a.5.5 0 0 1 .5-.5",
  clipRule: "evenodd"
})));
export default SvgDownload;